import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 5.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.948 8.092a2.396 2.396 0 0 1 1.802-.842h3.75a.75.75 0 0 1 0 1.5h-3.75a.899.899 0 0 0-.673.33c-.2.229-.327.559-.327.92s.127.691.327.92c.198.226.443.33.673.33h2.5c.698 0 1.343.318 1.802.842.456.521.698 1.209.698 1.908 0 .7-.242 1.387-.698 1.908-.459.524-1.104.842-1.802.842H9a.75.75 0 0 1 0-1.5h4.25c.23 0 .475-.104.673-.33.2-.229.327-.559.327-.92s-.127-.691-.327-.92a.899.899 0 0 0-.673-.33h-2.5c-.698 0-1.343-.318-1.802-.842A2.903 2.903 0 0 1 8.25 10c0-.7.242-1.387.698-1.908Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }